import { ref } from "vue";

export function useConfirmModal() {
  const showConfirmModal = ref(false);
  const confirmTitle = ref("");
  const confirmText = ref("");
  const confirmButtonText = ref("Aceptar");
  const cancelButtonText = ref("Cancelar");
  const confirmButtonClass = ref("btn btn-xs ms-1 bg-gradient-primary");
  const cancelButtonClass = ref("btn btn-xs btn-outline-primary me-1");
  const confirmLoading = ref(false);

  let onConfirmAction = null;

  function openConfirmModal(options = {}) {
    confirmTitle.value = options.title || "";
    confirmText.value = options.text || "";
    confirmButtonText.value = options.confirmButtonText || "Aceptar";
    cancelButtonText.value = options.cancelButtonText || "Cancelar";
    confirmButtonClass.value =
      options.confirmButtonClass || "btn btn-xs ms-1 bg-gradient-primary";
    cancelButtonClass.value =
      options.cancelButtonClass || "btn btn-xs btn-outline-primary me-1";
    confirmLoading.value = false;
    onConfirmAction = typeof options.onConfirm === "function" ? options.onConfirm : null;
    showConfirmModal.value = true;
  }

  function closeConfirmModal() {
    showConfirmModal.value = false;
    confirmLoading.value = false;
    onConfirmAction = null;
  }

  async function handleConfirmModal() {
    if (!onConfirmAction) {
      closeConfirmModal();
      return;
    }

    confirmLoading.value = true;
    const result = await onConfirmAction();
    confirmLoading.value = false;

    if (result === false) return;
    closeConfirmModal();
  }

  return {
    showConfirmModal,
    confirmTitle,
    confirmText,
    confirmButtonText,
    cancelButtonText,
    confirmButtonClass,
    cancelButtonClass,
    confirmLoading,
    openConfirmModal,
    closeConfirmModal,
    handleConfirmModal,
  };
}
